import { useState } from 'react';
import Api from 'api';
import { useDefferedCallback } from 'utils/hooks';

export const useProjectsCards = (projectsKey, lang) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = () => {
    Api.getProjectsCards(projectsKey, lang)
      .then(res => {
        if (Array.isArray(res)) {
          setProjects(res);
        }
      })
      .finally(() => setLoading(false));
  };

  const { inViewRef } = useDefferedCallback(fetchData, {
    rootMargin: '100% 0% 100% 0%',
    delay: 7000,
  });

  return { inViewRef, projects, loading };
};
